import React from "react";
import * as styles from "./style.module.scss";
import Chip from "@mui/material/Chip";

const NotificationLabel = ({ label }) => {
  return (
    <Chip
      className={styles.labelChip}
      color="secondary"
      variant="outlined"
      size="small"
      label={label}
    />
  );
};

export default NotificationLabel;
